export default "__VITE_ASSET__COfgFLV9__"